import Nullstack from 'nullstack';
export default function IconCurrencyRenminbi({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-currency-renminbi",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 9v8a2 2 0 1 0 4 0"
  }), "   ", Nullstack.element("path", {
    d: "M19 9h-14"
  }), "   ", Nullstack.element("path", {
    d: "M19 5h-14"
  }), "   ", Nullstack.element("path", {
    d: "M9 9v4c0 2.5 -.667 4 -2 6"
  }), " ");
}